import { Container, Typography } from '@mui/material';

const MonitoringSpecification = () => (
  <Container maxWidth="lg">
    <Typography variant="h4" color="primary">
      Monitoring specification: Coming soon
    </Typography>
  </Container>
);

export default MonitoringSpecification;
